const meta = {
  'deployment-strategies': 'Deployment strategies',
  files: 'Files',
  helm: 'Helm configuration',
  'history-rollback': 'History and rollback',
  kubernetes: 'Kubernetes settings',
  metadata: 'Metadata',
  networking: 'Networking',
  'config-files': 'Pipeline configuration files',
  'resource-profiles': 'Resource profiles',
  scaling: 'Scaling and replicas',
  secrets: 'Secrets',
};

export default meta;
